module.exports = __webpack_public_path__ + "./imgs/zyyw_bg.jpg?aa8df198ddcd5756ddcf74eecd2c7c0d";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/business/zyyw_bg.jpg
// module id = 13
// module chunks = 0 4 5 6